import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // ✅ Tailwind works

import App from './App';
import { BrowserRouter } from 'react-router-dom'; // ✅ Import BrowserRouter

const rootElement = document.getElementById('root');

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
